import { jsx as _jsx } from "react/jsx-runtime";
import { ReactComponent as AdaBigIcon } from '../../assets/icons/icon-ada-big.svg';
import styles from './index.module.scss';
import cn from 'classnames';
const AdaIcon = () => {
    return (_jsx("div", Object.assign({ className: cn(styles.adaIcon) }, { children: _jsx(AdaBigIcon, {}) })));
};
export default AdaIcon;
